module.exports = __webpack_public_path__ + "static/media/subtract-circle 1.22d1500e.svg";